import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { depositFunds } from '../../../api';
import MyButton from '../../basic/MyButton';
import MyTextInput from '../../basic/MyTextInput';
import MyCloseButton from '../../basic/MyCloseButton';
import './modalDepositFundsChild.css';

Modal.setAppElement('#root');

function DepositModal({ isOpen, onClose, childId, childName, onDepositSuccess }) {
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            setAmount('');
            setReason('');
            setError('');
            setLoading(false);
        }
    }, [isOpen]);

    const handleDeposit = async () => {
        if (!amount) {
            setError('Please fill the amount field.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            const data = await depositFunds(childId, parseFloat(amount), reason);
            onDepositSuccess();
            onClose();
        } catch (err) {
            console.error('Error during deposit:', err);
            setError('Failed to deposit funds.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="modal-content"
            overlayClassName="modal-overlay"
            shouldCloseOnOverlayClick={true}
        >   
            <div onClick={(e) => e.stopPropagation()}>
                <h2>Deposit Funds to {childName}'s Accounts</h2>
                <p>Deposits will be distributed accross {childName}'s accounts based on Income split configuration</p>
                <MyTextInput
                    label="Amount"
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter deposit amount"
                />
                <MyTextInput
                    label="Reason (optional)"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Enter reason for deposit (Optional)"
                />
                <h5>Examples: "Present from grandparents", "Payment for washing the car" </h5>
                {error && <p className="error-message">{error}</p>}
                <MyButton text={loading ? 'Processing...' : 'Deposit'} onClick={handleDeposit} />
                <MyButton 
                    text="Cancel" 
                    onClick={onClose} 
                    backgroundColor="white"
                    color="#dc3545"
                    hoverBackgroundColor="#f8f8f8"
                    hoverColor="#c82333"
                />
            </div>
        </Modal>
    );
}

export default DepositModal;